var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('logo-layout',{attrs:{"title":_vm.$t('pages.incrustado.aviso'),"description":_vm.reservaUsuario ? 
    _vm.getTexto('error.reservado') :
    _vm.getTexto('error.noDisponible')}},[(_vm.reservaUsuario && _vm.mostrarBoton)?_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"target":"_top","color":"primary","href":_vm.rutaPortal}},[_vm._v("\n      "+_vm._s(_vm.$t('incrustado.portalCD'))+"\n    ")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a144850","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/incrustado/mensajeReservado.vue
// module id = null
// module chunks = 